// src/firebase.js - Super Admin Dashboard

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";

// نفس الـ Firebase config (نفس المشروع)
const firebaseConfig = {
  apiKey: "AIzaSyAqITuHdKJqz0KPC5vhUfD-50JYxFfyGus",
  authDomain: "orders-confirmation-2c963.firebaseapp.com",
  projectId: "orders-confirmation-2c963",
  storageBucket: "orders-confirmation-2c963.firebasestorage.app",
  messagingSenderId: "49350052043",
  appId: "1:49350052043:web:ef84416f6d2a40419eb34e",
  measurementId: "G-7R1SNH9L8P",
  databaseURL: "https://orders-confirmation-2c963-default-rtdb.europe-west1.firebasedatabase.app"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const rtDb = getDatabase(app);
const functions = getFunctions(app);

// 🔥 دالة لحذف العميل (تستدعي Cloud Function)
export const callDeleteClient = async (clientData) => {
  const deleteClientFunction = httpsCallable(functions, 'deleteClient');
  try {
    console.log('🔥 Calling deleteClient with:', {
      clientId: clientData.id,
      authUid: clientData.auth_uid,
      brandName: clientData.brand_name
    });
    
    const result = await deleteClientFunction({ 
      clientId: clientData.id,
      authUid: clientData.auth_uid
    });
    
    console.log('✅ Delete result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Error calling deleteClient:', error);
    throw new Error(error.message || 'فشل حذف العميل');
  }
};

